import { Box, Divider, Flex, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { StripePayment, StripePaymentConfigTypes } from "./StripePayment";
import { OwnerPaymentServiceTokenTypes } from "../types";
import { TaxShippingData } from "./PurchasePodModalBody";

interface PaymentStepProps {
  waiting: boolean;
  completePurchase: (config: StripePaymentConfigTypes) => void;
  submitButtonText: string;
  cardValidationError?: string;
  failedCard?: OwnerPaymentServiceTokenTypes;
  onEditAddress: () => void;
  productPrice?: number;
  taxShippingData?: TaxShippingData | null;
}

export function PaymentStep({
  waiting,
  completePurchase,
  submitButtonText,
  cardValidationError,
  failedCard,
  onEditAddress,
  productPrice,
  taxShippingData,
}: PaymentStepProps) {
  return (
    <>
      {/* Price Breakdown */}
      {taxShippingData && productPrice !== undefined && (
        <Box
          bg="transparent.white.10"
          borderRadius="16px"
          p="16px"
          mb="8px"
        >
          <Flex justifyContent="space-between" mb="8px">
            <Text fontSize="14px" color="dune.400">
              {t("components.payments.pod.product")}
            </Text>
            <Text fontSize="14px" color="dune.600">
              ${productPrice.toFixed(2)}
            </Text>
          </Flex>
          <Flex justifyContent="space-between" mb="8px">
            <Text fontSize="14px" color="dune.400">
              {t("components.payments.pod.shipping")}
            </Text>
            <Text fontSize="14px" color="dune.600">
              ${taxShippingData.shipping.toFixed(2)}
            </Text>
          </Flex>
          <Flex justifyContent="space-between" mb="12px">
            <Text fontSize="14px" color="dune.400">
              {t("components.payments.pod.taxes")}
            </Text>
            <Text fontSize="14px" color="dune.600">
              ${taxShippingData.taxes.toFixed(2)}
            </Text>
          </Flex>
          <Divider borderColor="transparent.white.20" mb="12px" />
          <Flex justifyContent="space-between">
            <Text fontSize="16px" fontWeight="600" color="dune.600">
              {t("components.payments.pod.total")}
            </Text>
            <Text fontSize="16px" fontWeight="600" color="blaze.blaze">
              ${taxShippingData.total.toFixed(2)}
            </Text>
          </Flex>
        </Box>
      )}

      <StripePayment
        waiting={waiting}
        completePurchase={completePurchase}
        submitButtonText={submitButtonText}
        responseError={cardValidationError}
        failedCard={failedCard}
      />

      <Text
        fontSize="12px"
        color="dune.400"
        textAlign="center"
        cursor="pointer"
        onClick={onEditAddress}
        _hover={{ textDecoration: "underline" }}
      >
        {t("components.payments.pod.editShippingAddress")}
      </Text>
    </>
  );
}
